export default __webpack_public_path__ + "static/img-10-140314d941cfd8439c4fda359972e5b6.png";